// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__oaD1O","row":"styles_row__L35GT"};